import Vue from 'vue'
import App from './App.vue'

// 引入element
import {
  Button,
  Dialog,
  Message,
  DatePicker
} from 'element-ui';

Vue.component(Button.name, Button);
Vue.component(Dialog.name, Dialog);
Vue.component(DatePicker.name, DatePicker);
Vue.prototype.$message = Message;

// 验证滑块
import dragVerify from "vue-drag-verify2";
Vue.component(dragVerify.name, dragVerify);

// 复制
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

Vue.config.productionTip = false;

new Vue({
  render: h => h(App),
}).$mount('#app')